class CustomSelect {
    constructor(config) {
        this.config = Object.assign({
            scope: '[data-custom-select="scope"]'
        }, config);

        this.$scope = $(this.config.scope);

        if(this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.$scope.each((index, element) => {
            let $element = $(element);
            let settings = Object.assign({
                theme: "bootstrap"
            }, $element.data('config'));

            if($element.data('url')) {
                settings.ajax = {
                    url: $element.data('url'),
                    dataType: 'json'
                }
            }
            $element.select2(settings);
        })
    }
}

export default CustomSelect;
